//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Row, Select, Image, Button } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import NotFoundData from "components/NotFoundData";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { GetDataOrderListData } from "services/interface";
import { useGetBankActiveList, useGetBankAllList } from "hooks/useFactory";
import OrderTableList from "components/OrderManage/OrderShipped/OrderTableList";
import SearchOrderForm from "../OrderTabsCard/SearchOrderForm";
import noImage from "assets/images/no-image.png";
import { checkSpeedMerchantStatus } from "services/ordersApi";
const { Option } = Select;

interface OrderShippedProps {
  data: GetDataOrderListData | undefined;
  isLoading: boolean;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string; // currentPage: number;
  refetchTo: () => void;
  IsHiddenPersonInfo?: boolean;
  setDateInput: Dispatch<SetStateAction<string>>;
  dateInput: string;
  refetchCredit?: () => void;
  setOpenForm?: Dispatch<SetStateAction<boolean>>;
}

const OrderShipped: FC<OrderShippedProps> = ({
  data,
  isLoading,
  refetch,
  setSearchInput,
  searchInput,
  refetchTo,
  IsHiddenPersonInfo,
  setDateInput,
  dateInput,
  refetchCredit,
  setOpenForm
}) => {
  const dispatch = useAppDispatch();
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: dataBank } = useGetBankActiveList(factory_id || "");
  const { contact } = useAppSelector((state) => state.auth);
  const userContactData = useAppSelector((state) => state.auth.contact);

  const [hasSpeedMerchant, setHasSpeedMerchant] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await checkSpeedMerchantStatus();
        if (res.status === "success") {
          setHasSpeedMerchant(res.data.has_speed_merchant);
        }
      } catch (error) {
        console.error("Failed to check speed merchant status", error);
      }
    };
    fetchStatus();
  }, []);

  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        <span style={{ fontSize: '12px' }}>
          <ImageWrapper>
            <Image src={item.image ?? noImage} alt={item.bank_name} preview={false} /> {item.bank_name} {item.account_no} {item.account_name}
          </ImageWrapper>
        </span>
      </Option>
    );
  });

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, isLoading]);

  // if (!data || data.order_data.length === 0) {
  //   return <NotFoundData text="ยังไม่มีรายการคำสั่งซื้อ" />;
  // }

  const refetchData = () => {
    refetch();
  };

  return (
    <>
      <WrapperAll>
        <HeadWrapper>
          <SearchOrderForm
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
          {setOpenForm && contact?.code === "lunganek" && (
            <Button type="primary" onClick={() => {
              setOpenForm(true);
            }}>
              เพิ่มคำสั่งซื้อ
            </Button>
          )}
        </HeadWrapper>
        <CardWrapperTable>
          <OrderTableList
            data={data}
            childrenBank={childrenBank}
            refetchData={refetchData}
            refetchTo={refetchTo}
            IsHiddenPersonInfo={IsHiddenPersonInfo}
            hasSpeedMerchant={hasSpeedMerchant}
            factory_id={userContactData?.id || ''}
          />
        </CardWrapperTable>
      </WrapperAll>
    </>
  );
};

export default OrderShipped;

// const PaginationWrapper = styled(Pagination)`
//   white-space: nowrap;
// `;
const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;  
  height: 20px; 
  img {
    width: 100%;
    height: 100%;
  }
`;